<!-- todo: consider renaming this component to 'Glide.vue' because it is not always a carousel but sometimes a slider -->

<template>
  <article class="rounded-xl overflow-hidden">
    <vue-glide
      v-if="slides.length > 0"
      ref="slider"
      v-model="activeSlide"
      :type="type"
      class="max-w-full"
      :breakpoints="breakpoints"
      :gap="32"
      :per-view="null"
      @glide:resize="onResize"
    >
      <vue-glide-slide v-for="(slide, index) in slides" :key="index">
        <slot name="slide" :slide="slide">
          <!-- The fallback slot consists of a very simple image and link -->
          <AtomLink :url="slide.url" class="flex flex-col w-full rounded-xl overflow-hidden">
            <figure v-if="slide.image">
              <MoleculePicture :image="slide.image" />
            </figure>
          </AtomLink>
        </slot>
      </vue-glide-slide>
    </vue-glide>

    <template v-if="slides.length > currentPerView">
      <div class="flex justify-center items-center">
        <button
          class="mt-4 min-w-[44px] flex justify-center focus:pr-2 cursor-pointer focus:ring-1 focus:ring-white focus:ring-offset-1 focus:rounded-md hover:text-app-green text-black transform transition duration-200"
          :aria-label="t_('prev')"
          @click="slider.glide.go('<')"
        >
          <AtomIconArrowLeft class="float-left w-4 md:float-right" />
        </button>
        <div class="text-black mt-3 w-1/5 text-center font-bold">{{ activeSlide + 1 }}/{{ slides.length }}</div>
        <button
          class="mt-4 min-w-[44px] flex justify-center cursor-pointer focus:ring-1 focus:ring-white focus:ring-offset-1 focus:rounded-md hover:text-app-green text-black transform transition duration-200"
          :aria-label="t_('next')"
          @click="slider.glide.go('>')"
        >
          <AtomIconArrowRight class="float-right w-4 md:float-left" />
        </button>
      </div>
    </template>
  </article>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  slides: { url: string; image?: string }[]
  type?: string
  breakpoints?: Record<number, Record<string, any>>
}

withDefaults(defineProps<Props>(), {
  type: 'carousel',
  breakpoints: () => ({
    639: { perView: 1 },
    1023: { perView: 2 },
    1749: { perView: 3 },
    999999: { perView: 4 },
  }),
})

const activeSlide = ref(0)
const currentPerView = ref(3)
const slider = ref()

const onResize = () => {
  currentPerView.value = slider.value?.glide.settings.perView || 3
}

onMounted(() => {
  currentPerView.value = slider.value?.glide.settings.perView || 3
})

const { t_ } = setupTranslationPrefixer('carousel')
</script>

<style lang="scss" scoped>
@import '@glidejs/glide/dist/css/glide.core';
@import '@glidejs/glide/dist/css/glide.theme';

.glide__slides {
  display: flex;
}

.glide__slide {
  display: flex;
  height: auto !important; // necessary to overwrite standard GlideJS height 100%
}
</style>
